import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Newspaper, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <section data-testid="blog-list-page" className="relative z-10 bg-[#0a0a0a] py-24 lg:py-36 border-t border-white/10 min-h-[70vh]">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-4">Ratgeber</p>
        <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-12">
          Tipps rund um dein iPhone.
        </h1>

        {loading ? (
          <p className="text-[#888] font-mono text-sm">Lädt…</p>
        ) : posts.length === 0 ? (
          <div data-testid="blog-list-empty" className="rounded-3xl border border-white/10 bg-[#050505] p-16 text-center">
            <Newspaper size={28} className="text-[#555] mx-auto mb-3" />
            <p className="text-[#888]">Bald findest du hier Artikel rund um iPhone-Reparaturen.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-testid="blog-list-grid">
            {posts.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}>
                <Link to={`/ratgeber/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                  className="group block rounded-3xl border border-white/10 bg-[#050505] overflow-hidden hover:border-white/25 transition-colors duration-500 h-full">
                  {p.cover_image_url && (
                    <div className="aspect-[16/9] overflow-hidden">
                      <img src={p.cover_image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="p-7">
                    <p className="font-mono text-xs text-[#666] mb-2">{new Date(p.created_at).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" })}</p>
                    <h2 className="font-display text-xl text-white">{p.title}</h2>
                    {p.excerpt && <p className="text-sm text-[#999] mt-2 leading-relaxed">{p.excerpt}</p>}
                    <p className="text-sm text-white mt-4 inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all">Weiterlesen <ArrowRight size={14} /></p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
